import styled from "@emotion/styled/macro";

export const TableWrapper = styled("div")`
  width: 100%;
  overflow: auto;
  border-radius: 6px;
  height: calc(100vh - 320px);
`;
export const Table = styled("table")`
  width: 100%;
  border-radius: 6px;
  border-collapse: collapse;
  box-shadow: 0px 0px 2px 1px #d1d1d1;
  background: #fff;
  position: relative;
`;
export const Td = styled("td")`
  padding: 12px;
  border-right: 1px solid rgba(82, 138, 234, 0.7);
`;
export const Tr = styled("tr")`
  & ${Td}:last-of-type {
    border-right: 0px solid #fff;
  }
`;

export const Th = styled("th")`
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.32) 0%,
      rgba(0, 0, 0, 0.32) 100%
    ),
    #627fe9;
  color: #fff;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-align: left;
  padding: 12px;
  border-right: 1px solid #ffffff;
  // position: sticky;
  // top: 0;
  // z-index: 10;
`;
export const THead = styled("thead")`
  & ${Th}:first-of-type {
    border-top-left-radius: 6px;
  }
  & ${Th}:last-of-type {
    border-top-right-radius: 6px;
    border-right: 0px solid #fff;
  }
`;
export const TBody = styled("tbody")`
  & ${Tr}:nth-of-type(even) {
    background: #eff2fd;
  }
`;
export const TFoot = styled("tfoot")`
 
`;
